import { render, staticRenderFns } from "./EmploymentStatuses.vue?vue&type=template&id=39c21bf6&scoped=true"
import script from "./EmploymentStatuses.vue?vue&type=script&lang=js"
export * from "./EmploymentStatuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c21bf6",
  null
  
)

export default component.exports